<template>
    <div>
        <p class="font-semibold" style="margin-bottom: -1.5rem">{{ params.data.callerMem }}</p>
        <p style="color: #a0aec0;" v-if="params.data.type_call == 'OUTCALL'">{{ params.data.hotline_number }}</p>
        <p style="color: #a0aec0;" v-if="params.data.type_call == 'INCALL'">{{ params.data.callerMemPhone }}</p>
        <p style="color: #a0aec0;" v-if="params.data.type_call == 'MISSCALL'">{{ params.data.callerMemPhone }}</p>
<!--        <div class="flex items-center gap-2" v-if="params.data.type_call == 'MISSCALL'">-->
<!--            <p style="color: #a0aec0;">{{ params.data.callerMemPhone }}</p>-->
<!--            <vx-tooltip class="position-icon flex items-center" :text="$t('button.call')" position="top"-->
<!--                        v-if="params.data.type_call == 'MISSCALL'">-->
<!--                <feather-icon icon="PhoneCallIcon" class="text-primary" @click.stop="callCustomer"-->
<!--                              svgClasses="h-5 w-5" v-if="params.data.type_call == 'MISSCALL'"/>-->
<!--            </vx-tooltip>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "CellRendererCaller",
    methods: {
        callCustomer() {
            console.log(1)
            // console.log(this.params.data.caller[0].employee)
            this.$eventBus.$emit("beauty-call", this.params.data.caller[0].employee);
        }
    }
}
</script>

<style scoped>

</style>
